import { FontAwesomeIcon, NavigationItem } from "@osn/react-components";

export type ParticipantNavigationItem = NavigationItem & {
  isCoachOnly?: boolean;
};

export const unloggedItems: ParticipantNavigationItem[] = [
  { href: "/login", label: "Login", icon: <FontAwesomeIcon icon="fa-shield-check" /> },
  { href: "/events", label: "Events", icon: <FontAwesomeIcon icon="fa-calendar" /> },
  { href: "/legal", label: "Legal", icon: <FontAwesomeIcon icon="fa-file-contract" /> },
];

export const primaryItems: ParticipantNavigationItem[] = [
  {
    href: "/home",
    label: "Home",
    icon: <FontAwesomeIcon icon="fa-house" />,
    group: "Play",
    displayInNavbar: true,
    navbarOrder: 0,
  },
  {
    href: "/schedule",
    label: "Schedule",
    icon: <FontAwesomeIcon icon="fa-calendar" style={{ marginLeft: "2px" }} />,
    group: "Play",
    displayInNavbar: true,
    navbarOrder: 1,
  },
  {
    href: "/trophy-hunt",
    label: "Trophy Hunt",
    icon: <FontAwesomeIcon icon="fa-trophy" />,
    group: "Play",
    displayInNavbar: true,
    navbarOrder: 3,
  },
  {
    href: "/shop",
    label: "Shop",
    icon: <FontAwesomeIcon icon="fa-store" />,
    group: "Play",
    displayInNavbar: true,
    navbarOrder: 4,
  },
  {
    href: "/events",
    label: "Events",
    icon: <FontAwesomeIcon icon="fa-calendar-day" />,
    group: "Play",
  },
  {
    href: "/registration",
    label: "Registration",
    icon: <FontAwesomeIcon icon="fa-circle-plus" />,
    group: "Manage",
  },
  {
    href: "/my-players",
    label: "My Players",
    icon: <FontAwesomeIcon icon="fa-people-roof" />,
    group: "Manage",
  },
  {
    href: "/my-teams",
    label: "My Teams",
    icon: <FontAwesomeIcon icon="fa-people-group" />,
    group: "Manage",
    isCoachOnly: true,
    displayInNavbar: true,
    navbarOrder: 2,
  },
  {
    href: "/invite-players",
    label: "Invite Players",
    icon: <FontAwesomeIcon icon="fa-diagram-project" />,
    group: "Manage",
    isCoachOnly: true,
  },
  {
    href: "/volunteer",
    label: "Volunteer",
    icon: <FontAwesomeIcon icon="fa-handshake-angle" />,
    group: "Manage",
  },
  {
    href: "/scorekeeping",
    label: "Scorekeeping",
    icon: <FontAwesomeIcon icon="fa-clipboard-list" />,
    group: "Manage",
  },
  // Not in the review's target list, but the drawer is the only way to reach Statkeeping, so it stays beside Scorekeeping.
  {
    href: "/statkeeping",
    label: "Statkeeping",
    icon: <FontAwesomeIcon icon="fa-chart-simple" />,
    group: "Manage",
  },
  { href: "/orders", label: "Orders", icon: <FontAwesomeIcon icon="fa-list" />, group: "Manage" },
  {
    href: "/personal-info",
    label: "Profile",
    icon: <FontAwesomeIcon icon="fa-user" />,
    group: "Account",
  },
  {
    href: "/security",
    label: "Security",
    icon: <FontAwesomeIcon icon="fa-shield-halved" />,
    group: "Account",
  },
  {
    href: "/manageCommsPreferences",
    label: "Notifications",
    icon: <FontAwesomeIcon icon="fa-bell" />,
    group: "Account",
  },
  {
    href: "/help",
    label: "Help & Support",
    icon: <FontAwesomeIcon icon="fa-circle-question" />,
    group: "Account",
  },
  {
    href: "/legal",
    label: "Legal",
    icon: <FontAwesomeIcon icon="fa-file-contract" />,
    group: "Account",
  },
];
